import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  OnDestroy,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuideStep, SpinnerSegment } from '../../Interfaces/interfaces';
import { ApiCallService } from '../../Services/api-call-service.service';
import Swal from 'sweetalert2';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { GameService } from '../../Services/game.service';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { LoaderService } from '../../Services/loader-service.service';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';

import {
  heroCurrencyDollar,
  heroGift,
  heroTrophy,
  heroUsers,
} from '@ng-icons/heroicons/outline';
import { ionDiamond } from '@ng-icons/ionicons';
import { hugeMoneyBag02 } from '@ng-icons/huge-icons';
import { UtilsService } from '../../Services/utils.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-spinner',
  standalone: true,
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [CommonModule, FontAwesomeModule, NgIcon],
  viewProviders: [
    provideIcons({
      heroUsers,
      heroTrophy,
      heroCurrencyDollar,
      heroGift,
      ionDiamond,
      hugeMoneyBag02,
    }),
  ],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  @Input() showHeaderSection: boolean = true;
  @Output() spinEnd = new EventEmitter<string>();

  isAmountCredited: boolean = true;

  private baseSegments: SpinnerSegment[] = [
    { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
    { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
    { id: 'seg-03', prize: '$3', icon: 'heroTrophy' },
    { id: 'seg-04', prize: '$5', icon: 'hugeMoneyBag02' },
    { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
    { id: 'seg-06', prize: '$8', icon: 'ionDiamond' },
    { id: 'seg-07', prize: '$9', icon: 'heroCurrencyDollar' },
    { id: 'seg-08', prize: '$13', icon: 'hugeMoneyBag02' },
    { id: 'seg-09', prize: '$15', icon: 'heroGift' },
    { id: 'seg-10', prize: '$20', icon: 'heroCurrencyDollar' },
  ];

  segments: SpinnerSegment[] = [...this.baseSegments];

  private readonly amountSegmentMap: Record<number, SpinnerSegment[]> = {
    1: [
      { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$1', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$2', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$2', icon: 'heroTrophy' },
      { id: 'seg-05', prize: '$0', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-07', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$5', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-10', prize: '$1', icon: 'heroGift' },
    ],
    2: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$0', icon: 'heroCurrencyDollar' },
      { id: 'seg-03', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-04', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$4', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$5', icon: 'ionDiamond' },
      { id: 'seg-08', prize: '$6', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$1', icon: 'heroGift' },
      { id: 'seg-10', prize: '$2', icon: 'heroCurrencyDollar' },
    ],
    3: [
      { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$1', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$2', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-05', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-06', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-07', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$7', icon: 'hugeMoneyBag02' },
      { id: 'seg-10', prize: '$9', icon: 'heroGift' },
    ],
    4: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$3', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$4', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$7', icon: 'ionDiamond' },
      { id: 'seg-07', prize: '$8', icon: 'hugeMoneyBag02' },
      { id: 'seg-08', prize: '$9', icon: 'heroCurrencyDollar' },
      { id: 'seg-09', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-10', prize: '$12', icon: 'heroGift' },
    ],

    5: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$3', icon: 'heroTrophy' },
      { id: 'seg-04', prize: '$5', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$8', icon: 'ionDiamond' },
      { id: 'seg-07', prize: '$9', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$13', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$15', icon: 'heroGift' },
      { id: 'seg-10', prize: '$20', icon: 'heroCurrencyDollar' },
    ],
    10: [
      { id: 'seg-01', prize: '$2', icon: 'heroTrophy' },
      { id: 'seg-10', prize: '$17', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$8', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-08', prize: '$12', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$7', icon: 'heroCurrencyDollar' },
      { id: 'seg-05', prize: '$20', icon: 'heroGift' },
      { id: 'seg-07', prize: '$10', icon: 'ionDiamond' },
      { id: 'seg-09', prize: '$14', icon: 'hugeMoneyBag02' },
    ],
    15: [
      { id: 'seg-01', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$25', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$8', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$19', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$10', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$17', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$13', icon: 'heroCurrencyDollar' },
      { id: 'seg-10', prize: '$30', icon: 'ionDiamond' },
      { id: 'seg-05', prize: '$15', icon: 'heroGift' },
      { id: 'seg-08', prize: '$22', icon: 'hugeMoneyBag02' },
    ],
    20: [
      { id: 'seg-01', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$45', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$10', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$35', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$15', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$30', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$20', icon: 'heroCurrencyDollar' },
      { id: 'seg-10', prize: '$50', icon: 'ionDiamond' },
      { id: 'seg-05', prize: '$25', icon: 'heroGift' },
      { id: 'seg-08', prize: '$40', icon: 'hugeMoneyBag02' },
    ],
  };

  private _spinAmount: string = '5';

  get spinAmount(): string {
    return this._spinAmount;
  }

  set spinAmount(value: string) {
    this._spinAmount = value;
    this.updateSegmentValues();
  }

  crossicon = faXmark;
  isSpinning = false;
  rotation = 0;
  lastWin: string | null = null;
  highlightedIndex: number | null = null;
  private highlightTimeout: any;
  private readonly HIGHLIGHT_DURATION_MS = 6000;

  customerid: any;
  private readonly SPIN_DURATION = 4000;
  private readonly MIN_SPINS = 5;

  public readonly segmentAngle = 360 / this.segments.length;

  isSpinAllowed!: boolean;

  remainingTimeInSeconds: number = 0;
  formattedTime: string = '';
  private countdownInterval: any;

  // --- Wheel geometry (SVG viewBox is 0 0 200 200, center 100,100) ---
  private readonly WHEEL_VIEWBOX = 200;
  private readonly WHEEL_R = 100;
  private readonly TEXT_R = 50;
  private readonly ICON_R = 72;

  private polar(radius: number, angleDeg: number): { x: number; y: number } {
    const rad = (angleDeg * Math.PI) / 180;
    return {
      x: 100 + radius * Math.cos(rad),
      y: 100 + radius * Math.sin(rad),
    };
  }

  private startAngle(i: number): number {
    return -90 + i * this.segmentAngle;
  }

  private midAngle(i: number): number {
    return this.startAngle(i) + this.segmentAngle / 2;
  }

  segmentPath(i: number): string {
    const start = this.polar(this.WHEEL_R, this.startAngle(i));
    const end = this.polar(this.WHEEL_R, this.startAngle(i) + this.segmentAngle);
    const largeArc = this.segmentAngle > 180 ? 1 : 0;
    return `M 100 100 L ${start.x.toFixed(2)} ${start.y.toFixed(2)} A ${this.WHEEL_R} ${this.WHEEL_R} 0 ${largeArc} 1 ${end.x.toFixed(2)} ${end.y.toFixed(2)} Z`;
  }

  segmentFill(i: number): string {
    return i % 2 === 0 ? '#15203a' : '#1f2d4d';
  }

  textTransform(i: number): string {
    const p = this.polar(this.TEXT_R, this.midAngle(i));
    return `rotate(${this.midAngle(i) + 90} ${p.x.toFixed(2)} ${p.y.toFixed(2)})`;
  }

  textX(i: number): number {
    return this.polar(this.TEXT_R, this.midAngle(i)).x;
  }

  textY(i: number): number {
    return this.polar(this.TEXT_R, this.midAngle(i)).y;
  }

  iconLeft(i: number): string {
    return `${(this.polar(this.ICON_R, this.midAngle(i)).x / this.WHEEL_VIEWBOX) * 100}%`;
  }

  iconTop(i: number): string {
    return `${(this.polar(this.ICON_R, this.midAngle(i)).y / this.WHEEL_VIEWBOX) * 100}%`;
  }

  iconRotate(i: number): string {
    return `${this.midAngle(i) + 90}deg`;
  }

  // --- Prize artwork rendered on each wedge (reference uses per-segment images) ---
  private readonly IMAGE_SIZE = 19;

  // Downloaded prize artwork (public/Images/Spinner). Reused across the 10 wedges
  // for now — swap these out per-segment later without touching the geometry.
  private readonly SPINNER_IMG_BASE = '/Images/Spinner/';
  wheelImages: string[] = [
    'prize_57750614-ae7d-43be-a151-5865b58abba9_df67e3509cef4dc69dc401c2d52b51e7.webp', // $1
    'prize_38b5d6eb-f2de-4905-88e5-217004a13af3_19db33966e744581afc7f63a3ddef9e2.webp', // $2
    'prize_e9cfd4df-61b0-4ca8-a4b5-edda3e9c4623_6aefbb6593df4d1da22414c331e7d635.webp', // $3
    'prize_9753e2d8-9915-4741-8979-9666323be2a6_c957eb4140264c11a6c692cf78662d5c.webp', // $4
    'prize_1d73b9f7-e9c1-4d9f-abb8-63498a1d8e61_acf51b231ff04578adf0b815268bdd39.webp', // $10
    'prize_3981d4d5-9b69-4679-b12d-697f03b6c23c_c89f3503a5ec4b9ab989f283e1a14d70.webp', // $100
    'prize_58803e3b-71af-4e7c-bf06-1cb714e15c0e_cc9340f3b49a47f49661f3200f54944f.webp', // Better Luck
    'prize_57750614-ae7d-43be-a151-5865b58abba9_df67e3509cef4dc69dc401c2d52b51e7.webp', // $1 (reuse)
    'prize_38b5d6eb-f2de-4905-88e5-217004a13af3_19db33966e744581afc7f63a3ddef9e2.webp', // $2 (reuse)
    'prize_e9cfd4df-61b0-4ca8-a4b5-edda3e9c4623_6aefbb6593df4d1da22414c331e7d635.webp', // $3 (reuse)
  ];

  segImage(i: number): string {
    const seg = this.segments[i];
    const file = seg?.image ?? this.wheelImages[i % this.wheelImages.length];
    return this.SPINNER_IMG_BASE + file;
  }

  imageX(i: number): number {
    return this.polar(this.ICON_R, this.midAngle(i)).x - this.IMAGE_SIZE / 2;
  }

  imageY(i: number): number {
    return this.polar(this.ICON_R, this.midAngle(i)).y - this.IMAGE_SIZE / 2;
  }

  imageTransform(i: number): string {
    const c = this.polar(this.ICON_R, this.midAngle(i));
    return `rotate(${this.midAngle(i) + 90} ${c.x.toFixed(2)} ${c.y.toFixed(2)})`;
  }

  get hubSubText(): string {
    if (this.isSpinning) return 'wait';
    if (this.freeSpinAvailable) return 'free';
    if (!this.isBalanceSufficient || !this.isSpinAllowed) return 'wait';
    return '$' + this.spinAmount;
  }

  constructor(
    private _apiCall: ApiCallService,
    private cdr: ChangeDetectorRef,
    private GameService: GameService,
    private _httpError: ErrorhandlingService,
    private loaderService: LoaderService,
    private router: Router,
    private _utils: UtilsService,
  ) {
    const customerId = localStorage.getItem('customerId');
    this.customerid = customerId;
  }

  isMobile() {
    return window.innerWidth < 768;
  }
  private lastBalanceFetchAt: number | null = null;
  private balanceFetchPromise: Promise<void> | null = null;
  private readonly BALANCE_TTL_MS = 15000;

  async ngOnInit(): Promise<void> {
    // Show the styled (reference-matched) scrollbar only on the spinner screen,
    // overriding the app-wide scrollbar-hide rules in styles.scss.
    document.documentElement.classList.add('spin-scrollbar');

    try {
      const saved = this.GameService.getTotalBalance?.();
      if (saved !== undefined && saved !== null) {
        const n = typeof saved === 'string' ? parseFloat(saved) : Number(saved);
        if (!Number.isNaN(n)) this.updateBalance = n;
      }
    } catch {}

    await this.ensureWalletBalance(true);

    await this.updateSegmentValues();

    if (!localStorage.getItem('totalBalance')) {
      this.getWalletBalance();
    }

    // Check free spin status on component init
    await this.checkFreeSpinStatus();
  }

  private ensureWalletBalance(force: boolean = false): Promise<void> {
    const now = Date.now();

    if (
      !force &&
      this.lastBalanceFetchAt !== null &&
      now - this.lastBalanceFetchAt < this.BALANCE_TTL_MS &&
      this.updateBalance !== undefined
    ) {
      return Promise.resolve();
    }

    if (this.balanceFetchPromise) {
      return this.balanceFetchPromise;
    }

    this.balanceFetchPromise = this.getWalletBalance()
      .then(() => {
        this.lastBalanceFetchAt = Date.now();
      })
      .catch(() => {})
      .finally(() => {
        this.balanceFetchPromise = null;
      });

    return this.balanceFetchPromise;
  }

  private async updateSegmentValues(): Promise<void> {
    // If free spin is available, show free spin values
    if (this.freeSpinAvailable) {
      this.updateSegmentsForFreeSpin();
      return;
    }

    const selectedRaw = parseFloat(this.spinAmount) || 5;
    const allowed = [1, 2, 3, 4, 5, 10, 15, 20];
    const selectedAmount = allowed.includes(selectedRaw) ? selectedRaw : 5;

    if (this.updateBalance === undefined || this.updateBalance === null) {
      await this.ensureWalletBalance(true);
    } else {
      this.ensureWalletBalance(false);
    }

    const bal = this.walletBalance;
    if (typeof bal === 'number') {
      this.isBalanceSufficient = selectedAmount <= bal;
      this.isSpinAllowed = this.isBalanceSufficient;
    } else {
      this.isBalanceSufficient = true;
      this.isSpinAllowed = true;
    }

    const mapped =
      this.amountSegmentMap[selectedAmount] || this.amountSegmentMap[5];

    this.segments = mapped.map((s) => ({ ...s }));

    this.cdr.detectChanges();
  }

    // Free Spin Properties
    // readonly freeSpinValues = [0, 1, 3, 2, 5, 4, 7, 6, 9, 8];
    private freeSpinValues: SpinnerSegment[] = [
        { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
        { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
        { id: 'seg-03', prize: '$1', icon: 'heroTrophy' },
        { id: 'seg-04', prize: '$3', icon: 'hugeMoneyBag02' },
        { id: 'seg-05', prize: '$5', icon: 'heroCurrencyDollar' },
        { id: 'seg-06', prize: '$4', icon: 'ionDiamond' },
        { id: 'seg-07', prize: '$6', icon: 'heroCurrencyDollar' },
        { id: 'seg-08', prize: '$9', icon: 'hugeMoneyBag02' },
        { id: 'seg-09', prize: '$7', icon: 'heroGift' },
        { id: 'seg-10', prize: '$8', icon: 'heroCurrencyDollar' },
    ];
  private updateSegmentsForFreeSpin(): void {
    // Create segments from free spin values (0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5)
    const icons = [
      'heroTrophy',
      'ionDiamond',
      'heroCurrencyDollar',
      'hugeMoneyBag02',
      'heroGift',
    ];
      this.segments = this.freeSpinValues;
    // this.segments = this.freeSpinValues.map((value, index) => ({
    //   id: `free-seg-${index + 1}`,
    //   prize: `$${value}`,
    //   icon: icons[index % icons.length],
    // }));

    this.isBalanceSufficient = true;
    this.isSpinAllowed = true;
    this.cdr.detectChanges();
  }

  // Free Spin Methods
  private async checkFreeSpinStatus(): Promise<void> {
    try {
      const customerId = localStorage.getItem('customerId');
      if (!customerId) {
        console.error('Customer ID not found');
        return;
      }

      // Call GetSpinner API to get the free spin status
      const response = await this._apiCall
        .GetCallWithToken('Spinner/GetSpinner?CustomerId=' + customerId)
        .toPromise();

      if (response?.responseCode === 200 && response.data) {
        this.fresspinWindowIsOpen = response.data.fresspinWindowIsOpen;
        // Ensure both times are treated as UTC to avoid timezone conversion issues
        let spinnerTimeStr = response.data.spinnerTime;
        // Add 'Z' suffix if not present to ensure UTC parsing
        if (!spinnerTimeStr.endsWith('Z')) {
          spinnerTimeStr += 'Z';
        }

        const spinnerTime = new Date(spinnerTimeStr);
        const serverDateTime = new Date(response.data.serverDateTime);

        // Calculate elapsed time since last spin (both in UTC)
        const elapsedMs = serverDateTime.getTime() - spinnerTime.getTime();
        const elapsedSeconds = Math.floor(elapsedMs / 1000);

        // Calculate remaining time until next free spin (24 hours - elapsed time)
        const totalCooldownSeconds = 24 * 60 * 60; // 24 hours in seconds
        const diffInSeconds = totalCooldownSeconds - elapsedSeconds;

        if (this.fresspinWindowIsOpen) {
          if (diffInSeconds <= 0) {
            // Cooldown has passed, free spin is available
            this.freeSpinAvailable = true;
            this.freeSpinRemainingTime = 0;
            this.freeSpinFormattedTime = '00:00:00';
            await this.updateSegmentValues();
          } else {
            // Still in cooldown period
            this.freeSpinAvailable = false;
            this.freeSpinRemainingTime = diffInSeconds;
            this.startFreeSpinCountdown();
          }
        } else {
          // Eligibility window is closed - lock free spin completely
          this.freeSpinAvailable = false;
          this.freeSpinRemainingTime = 0;
          this.freeSpinFormattedTime = '00:00:00';
          await this.updateSegmentValues();
        }
      } else {
        // If API fails or no data, allow free spin by default
        this.fresspinWindowIsOpen = true;
        this.freeSpinAvailable = true;
        this.freeSpinRemainingTime = 0;
        this.freeSpinFormattedTime = '00:00:00';
        await this.updateSegmentValues();
      }

      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error checking free spin status:', error);
      // Allow free spin if API call fails
      this.fresspinWindowIsOpen = true;
      this.freeSpinAvailable = true;
      this.freeSpinRemainingTime = 0;
      this.freeSpinFormattedTime = '00:00:00';
      await this.updateSegmentValues();
    }
  }

  private startFreeSpinCountdown(): void {
    if (this.freeSpinCountdownInterval) {
      clearInterval(this.freeSpinCountdownInterval);
    }

    if (!this.fresspinWindowIsOpen || this.freeSpinRemainingTime <= 0) {
      if (this.fresspinWindowIsOpen) this.freeSpinAvailable = true;
      this.cdr.detectChanges();
      return;
    }

    this.updateFreeSpinFormattedTime();

    this.freeSpinCountdownInterval = setInterval(() => {
      if (this.freeSpinRemainingTime > 0) {
        this.freeSpinRemainingTime -= 1;
        this.updateFreeSpinFormattedTime();

        if (this.freeSpinRemainingTime === 0) {
          if (this.fresspinWindowIsOpen) {
            this.freeSpinAvailable = true;
            clearInterval(this.freeSpinCountdownInterval);
            Swal.fire({
              icon: 'success',
              title: 'Free Spin Available',
              text: 'Your daily free spin is now available!',
              customClass: { popup: 'swal-compact' },
            });
            // Make sure the wheel now displays free-spin segment values
            this.updateSegmentsForFreeSpin();
          } else {
            this.freeSpinAvailable = false;
            clearInterval(this.freeSpinCountdownInterval);
          }
        }

        this.cdr.detectChanges();
      }
    }, 1000);
  }

  private updateFreeSpinFormattedTime(): void {
    const hours = Math.floor(this.freeSpinRemainingTime / 3600);
    const minutes = Math.floor((this.freeSpinRemainingTime % 3600) / 60);
    const seconds = this.freeSpinRemainingTime % 60;

    this.freeSpinFormattedTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private async executeFreeSpin(): Promise<void> {
    const selectedAmount = this.freeSpinValues[0]; // Default to first free spin value
    this.spinAmount = '5';

    // Ensure wheel shows free-spin segment values before spinning
    this.updateSegmentsForFreeSpin();

    this.isSpinning = true;
    this.startSpinAnimation();

    // Call the free spin API endpoint with isFreeSpin flag
    const payload = {
      customerid: Number(localStorage.getItem('customerId')),
      isFreeSpin: true,
    };

    this._apiCall.PostCallWithToken(payload, 'Spinner/Spinner').subscribe(
      async (response) => {
        if (response.responseCode === 200) {
          // After successful free spin, re-check status via API
          const winningAmount = response.data?.reward || 0;
          this.customerBetWinningAmount = winningAmount;

          setTimeout(() => {
            this.loaderService?.triggerWalletFunction();
          }, 2500);

          // Complete the spin animation
          if (this.currentSpinInterval) {
            clearInterval(this.currentSpinInterval);
            this.currentSpinInterval = null;
          }

          const prizeIndex = this.segments.findIndex(
            (segment) => segment.prize === '$' + winningAmount,
          );

          if (prizeIndex === -1) {
            const hasCloseMatch = this.findClosestPrizeMatch(winningAmount);
            if (!hasCloseMatch) {
              this.completeSpinToRandomIndex();
            } else {
              this.completeSpinToTarget(winningAmount);
            }
          } else {
            this.completeSpinToTarget(winningAmount);
          }

          // Reset free spin availability and re-check via API
          await this.checkFreeSpinStatus();
        } else if (
          response.responseCode === 400 &&
          response.errorMessage?.includes('already spined')
        ) {
          // User already used free spin today, allow paid spin with original amount
          this.stopSpinningWithError();
          this.freeSpinAvailable = false;

          // Reset to default paid spin amount
          this.spinAmount = '5';
          await this.updateSegmentValues();

          Swal.fire({
            icon: 'info',
            title: 'Free Spin Used',
            text:
              response.errorMessage ||
              'You have already spun today. Please use paid spin.',
            customClass: { popup: 'swal-compact' },
          });
        } else {
          this.stopSpinningWithError();
          this._httpError.handleResponseError(response);
        }
      },
      (error) => {
        this.stopSpinningWithError();
        this._httpError.handleHttpError(error);
      },
    );
  }

  freespincheck: boolean = false;
  paidSpin() {
    if (this.isSpinning || !this.checkTotalBalance()) return;
    this.rotation = 0;
    this.SpinAgainModal = false;
    this.isFreeSpin = false;
    this.highlightedIndex = null;
    if (this.highlightTimeout) clearTimeout(this.highlightTimeout);
    this.testSpin();
  }

  isBalanceSufficient: boolean = false;

  async freeSpin() {
    // If free spin is available, execute free spin instead of paid spin
    if (this.freeSpinAvailable) {
      this.executeFreeSpin();
      return;
    }

    const selectedAmount = parseFloat(this.spinAmount) || 5;

    this.ensureWalletBalance(false);

    const bal = this.walletBalance;
    if (typeof bal === 'number' && selectedAmount > bal) {
      this.isBalanceSufficient = false;
      Swal.fire({
        icon: 'warning',
        title: 'Insufficient Balance',
        text: 'Insufficient balance. Please add funds to your wallet.',
        customClass: { popup: 'swal-compact' },
      });
      return;
    }

    this.isSpinAllowed = true;
    this.isBalanceSufficient = true;

    await this.updateSegmentValues();

    this.startSpinAnimation();

    this.customerBetWithoutLoader();
  }

  private startSpinAnimation(): void {
    if (this.isSpinning) return;

    this.isSpinning = true;
    document.body.style.pointerEvents = 'none';
    this.highlightedIndex = null;
    if (this.highlightTimeout) clearTimeout(this.highlightTimeout);

    const spinnerContainer = document.querySelector('.spinner-container');
    spinnerContainer?.classList.add('spinning');

    let speed = 20;
    let rotationStep = -20;

    const spinInterval = setInterval(() => {
      this.rotation += rotationStep;
      if (speed < 80) {
        speed += 0.3;
        clearInterval(spinInterval);
        setTimeout(() => {
          const newInterval = setInterval(() => {
            this.rotation += rotationStep;
          }, speed);

          this.currentSpinInterval = newInterval;
        }, speed);
      }
    }, speed);

    this.currentSpinInterval = spinInterval;
  }

  private currentSpinInterval: any = null;

  private checkTotalBalance(): boolean {
    if (!localStorage.getItem('totalBalance')) {
      this.getWalletBalance();
      return false;
    }
    return true;
  }

  testSpin(winningIndex?: number): void {
    if (this.isSpinning) return;
    this.isSpinning = true;
    document.body.style.pointerEvents = 'none';
    this.highlightedIndex = null;
    if (this.highlightTimeout) clearTimeout(this.highlightTimeout);

    const spinnerContainer = document.querySelector('.spinner-container');
    spinnerContainer?.classList.add('spinning');

    const segmentAngle = this.segmentAngle;

    let chosenIndex: number;

    if (typeof winningIndex === 'number' && winningIndex > 0) {
      const prizeToFind = '$' + winningIndex;

      this.segments.forEach((segment, index) => {});

      const prizeIndex = this.segments.findIndex(
        (segment) => segment.prize === prizeToFind,
      );

      if (prizeIndex !== -1) {
        chosenIndex = prizeIndex;
      } else {
        const numericPrizes = this.segments.map((segment) => {
          const numValue = parseFloat(segment.prize.replace(/[^0-9.]/g, ''));
          return {
            index: this.segments.indexOf(segment),
            id: segment.id,
            prize: segment.prize,
            numValue: numValue,
            difference: Math.abs(numValue - winningIndex),
          };
        });

        numericPrizes.sort((a, b) => a.difference - b.difference);

        if (numericPrizes.length > 0) {
          chosenIndex = numericPrizes[0].index;
        } else {
          chosenIndex = Math.floor(Math.random() * this.segments.length);
        }
      }
    } else {
      chosenIndex = Math.floor(Math.random() * this.segments.length);
    }

    const currentPointerAngle = ((-this.rotation % 360) + 360) % 360;
    const sliceStart = chosenIndex * segmentAngle;
    const sliceEnd = sliceStart + segmentAngle;
    const desiredCenterAngle = sliceStart + segmentAngle / 2;

    const settleOffset = 8 + Math.random() * 10;

    let delta = (desiredCenterAngle - currentPointerAngle + 360) % 360;
    const FULL_ROTATIONS = 8;
    delta += FULL_ROTATIONS * 360;
    const finalTargetRotation = this.rotation - delta + settleOffset;

    const startTime = performance.now();
    const initialRotation = this.rotation;
    const totalDistance = Math.abs(finalTargetRotation - initialRotation);

    const FAST_PHASE_DURATION = 4000;
    const SLOW_PHASE_DURATION = 3000;
    const TOTAL_DURATION = FAST_PHASE_DURATION + SLOW_PHASE_DURATION;

    let animationFrame: number;

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / TOTAL_DURATION, 1);

      let currentRotation: number;

      if (elapsed <= FAST_PHASE_DURATION) {
        const fastProgress = elapsed / FAST_PHASE_DURATION;
        const fastDistance = totalDistance * 0.85;
        currentRotation = initialRotation - fastDistance * fastProgress;
      } else {
        const slowProgress =
          (elapsed - FAST_PHASE_DURATION) / SLOW_PHASE_DURATION;

        const easedProgress = 1 - Math.pow(1 - slowProgress, 3);

        const fastDistance = totalDistance * 0.85;
        const remainingDistance = totalDistance * 0.15;

        currentRotation =
          initialRotation - fastDistance - remainingDistance * easedProgress;
      }

      this.rotation = currentRotation;
      if (progress >= 1) {
        this.rotation = finalTargetRotation;
        this.completeSpinAnimation(
          chosenIndex,
          spinnerContainer,
          sliceStart,
          sliceEnd,
          desiredCenterAngle,
        );
        return;
      }

      this.cdr.detectChanges();

      animationFrame = requestAnimationFrame(animate);
    };

    animationFrame = requestAnimationFrame(animate);

    setTimeout(
      () => {
        if (this.isSpinning) {
          spinnerContainer?.classList.remove('spinning');
          spinnerContainer?.classList.add('spin-ending');
        }
      },
      FAST_PHASE_DURATION + SLOW_PHASE_DURATION * 0.7,
    );
  }

  private completeSpinAnimation(
    chosenIndex: number,
    spinnerContainer: Element | null,
    sliceStart: number,
    sliceEnd: number,
    desiredCenterAngle: number,
    onComplete?: () => void,
  ): void {
    const seg = this.segments[chosenIndex];

    this.lastWin = seg.prize;

    if (this.customerBetWinningAmount > 0) {
      const actualWinningAmount = parseFloat(seg.prize.replace(/[^0-9.]/g, ''));
      this.lastWin = '$' + this.customerBetWinningAmount;
    }

    this.highlightedIndex = chosenIndex;
    this.spinEnd.emit(this.lastWin);

    this.isSpinning = false;
    document.body.style.pointerEvents = 'auto';

    spinnerContainer?.classList.remove('spinning', 'spin-ending');

    if (seg.prize === 'Free Spin') {
      setTimeout(() => {
        this.testSpin();
      }, 1000);
    }

    this.customerBetWinningAmount = 0;

    this.scheduleHighlightClear();
    this.cdr.markForCheck();
    this.addPointerSettleEffect();

    setTimeout(() => {
      spinnerContainer?.classList.remove('spin-ending');
      if (onComplete) onComplete();
    }, 3000);
  }
  private addPointerSettleEffect(): void {
    const pointer = document.querySelector('.wheel-pointer');
    if (!pointer) return;
    pointer.classList.add('settling');

    const settleOffset = 8 + Math.random() * 5;
    const finalRotation = this.rotation + settleOffset;

    let startTime = performance.now();
    const startRotation = this.rotation;
    const duration = 800;

    const settleAnimate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easedProgress = 1 - Math.pow(1 - progress, 3);

      this.rotation =
        startRotation + (finalRotation - startRotation) * easedProgress;

      if (progress < 1) {
        this.cdr.detectChanges();
        // requestAnimationFrame(settleAnimate);
      } else {
        this.rotation = finalRotation;
        this.cdr.detectChanges();

        setTimeout(() => {
          pointer.classList.remove('settling');
        }, 100);
      }
    };
    setTimeout(() => {
      // requestAnimationFrame(settleAnimate);
    }, 200);
  }

  private scheduleHighlightClear() {
    if (this.highlightTimeout) clearTimeout(this.highlightTimeout);
    this.highlightTimeout = setTimeout(() => {
      if (!this.isSpinning) {
        this.highlightedIndex = null;
        this.cdr.markForCheck();
      }
    }, this.HIGHLIGHT_DURATION_MS);
  }

  resetSpinner() {
    this.lastWin = null;
    this.highlightedIndex = null;
    this.isSpinning = false;
  }

  serverTimeData: any;
  sppinertime: any;

  CheckIfSpinAllowed(serverTimeData: string, spinTime: string): boolean {
    const serverDate = new Date(serverTimeData);
    const spinDate = new Date(spinTime + 'Z');

    if (
      serverDate.getUTCFullYear() === spinDate.getUTCFullYear() &&
      serverDate.getUTCMonth() === spinDate.getUTCMonth() &&
      serverDate.getUTCDate() === spinDate.getUTCDate()
    ) {
      return false;
    } else {
      return true;
    }
  }

  calculateRemainingTime(spinnerTime: string, serverDateTime: string) {
    try {
      const spinDateTime = new Date(spinnerTime);
      const serverDateTimeObj = new Date(serverDateTime);

      const nextDayStart = new Date(
        Date.UTC(
          serverDateTimeObj.getUTCFullYear(),
          serverDateTimeObj.getUTCMonth(),
          serverDateTimeObj.getUTCDate() + 1,
        ),
      );

      const differenceInSeconds = Math.floor(
        (nextDayStart.getTime() - serverDateTimeObj.getTime()) / 1000,
      );

      this.remainingTimeInSeconds = Math.max(differenceInSeconds, 0);

      if (this.remainingTimeInSeconds > 0) {
        this.startCountdown();
      } else {
      }

      this.cdr.detectChanges();
    } catch (error) {
      this.remainingTimeInSeconds = 0;
    }
  }

  private interval: any;

  startCountdown() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.remainingTimeInSeconds <= 0) {
      this.freespincheck = false;
      this.isFreeSpin = true;
      Swal.fire({
        icon: 'info',
        title: 'Rewards',
        text: 'Rewards, Your daily free spin is ready',
        customClass: { popup: 'swal-compact' },
      });
      return;
    }

    this.interval = setInterval(() => {
      if (this.remainingTimeInSeconds > 0) {
        this.remainingTimeInSeconds -= 1;

        const hours = Math.floor(this.remainingTimeInSeconds / 3600);
        const minutes = Math.floor((this.remainingTimeInSeconds % 3600) / 60);
        const seconds = this.remainingTimeInSeconds % 60;

        this.formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        this.cdr.detectChanges();
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    document.documentElement.classList.remove('spin-scrollbar');
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.highlightTimeout) {
      clearTimeout(this.highlightTimeout);
    }
    if (this.freeSpinCountdownInterval) {
      clearInterval(this.freeSpinCountdownInterval);
    }
  }

  updateFormattedTime() {
    const hours = Math.floor(this.remainingTimeInSeconds / 3600);
    const minutes = Math.floor((this.remainingTimeInSeconds % 3600) / 60);
    const seconds = this.remainingTimeInSeconds % 60;

    this.formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    this.cdr.detectChanges();
  }

  private updateBalance: any;

  get walletBalance(): any {
    return this.updateBalance;
  }

  WalletPayload() {
    return {
      customerId: Number(localStorage.getItem('customerId')),
      pageNumber: 1,
      pageSize: 10,
      searchText: '',
      startDate: '',
      endDate: '',
    };
  }
  //   getWalletBalance(pageNumber: number = 1, searchText: string = '') {
  //     this.loaderService.show();
  //     const CustomerID = localStorage.getItem('customerId');
  //     // let payload = `Wallet/GetWalletBalance?CustomerId=${CustomerID}&PageNumber=${pageNumber}&PageSize=${10}`;
  //     let payload = this.WalletPayload();

  //     // if (searchText.trim()) {
  //     //   payload += `&SearchText=${encodeURIComponent(searchText.trim())}`;
  //     // }

  //     this.apiCallService.PostCallWithToken(payload, 'Wallet/GetWalletBalance').subscribe(

  private getWalletBalance(): Promise<void> {
    return new Promise((resolve, reject) => {
      const CustomerID = localStorage.getItem('customerId');
      const payload = this.WalletPayload();

      this._apiCall
        .PostCallWithToken(payload, 'Wallet/GetWalletBalance')
        .subscribe(
          (response) => {
            if (response && response.responseCode === 200) {
              this.updateBalance = parseFloat(response.data.totalBalance || 0);
              this.GameService.saveTotalBalance(
                response.data.totalBalance || 0,
              );
              this.cdr.detectChanges();
              resolve();
            } else {
              this._httpError.handleResponseError(response);
              reject();
            }
          },
          (error) => {
            this._httpError.handleHttpError(error);
            reject(error);
          },
        );
    });
  }

  SpinAgainModal = false;

  OpenSpinAgain() {
    this.isAmountCredited = false;
    this.getWalletBalance();
    this.SpinAgainModal = true;
  }

  CloseSpinAgainModal() {
    this.SpinAgainModal = false;
  }

  isFreeSpin: boolean = false;

  redirectToLottery() {
    this.router.navigate(['/dashboard/lottery']);
  }

  // incrementSpinAmount(): void {
  //   let currentAmount = Math.floor(parseFloat(this.spinAmount) || 5);
  //   if (currentAmount < 5) currentAmount = 5;
  //   const next = Math.min(20, currentAmount + 5);
  //   this.spinAmount = next.toString();
  // }

  // decrementSpinAmount(): void {
  //   let currentAmount = Math.floor(parseFloat(this.spinAmount) || 5);
  //   if (currentAmount < 5) currentAmount = 5;
  //   const next = Math.max(5, currentAmount - 5);
  //   this.spinAmount = next.toString();
  // }
  allowedSpinAmounts = [1, 2, 3, 4, 5, 10, 15, 20];

  freeSpinAvailable: boolean = false;
  fresspinWindowIsOpen: boolean = true;
  freeSpinRemainingTime: number = 0;
  freeSpinFormattedTime: string = '';
  private freeSpinCountdownInterval: any;

  incrementSpinAmount(): void {
    let current = Number(this.spinAmount) || 1;

    const idx = this.allowedSpinAmounts.indexOf(current);
    if (idx < this.allowedSpinAmounts.length - 1) {
      this.spinAmount = this.allowedSpinAmounts[idx + 1].toString();
    }
  }

  decrementSpinAmount(): void {
    let current = Number(this.spinAmount) || 1;

    const idx = this.allowedSpinAmounts.indexOf(current);
    if (idx > 0) {
      this.spinAmount = this.allowedSpinAmounts[idx - 1].toString();
    }
  }

  private getNextValidAmount(
    currentAmount: number,
    increment: boolean,
  ): number {
    const validAmounts = [5, 8, 10, 12, 15, 25, 50, 100];
    const currentIndex = validAmounts.indexOf(currentAmount);

    if (increment && currentIndex < validAmounts.length - 1) {
      return validAmounts[currentIndex + 1];
    } else if (!increment && currentIndex > 0) {
      return validAmounts[currentIndex - 1];
    }

    return currentAmount;
  }

  onCentralHubClick(event: Event): void {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    if (this.isSpinning || !this.spinAmount || !this.isSpinAllowed) {
      return;
    }

    this.freeSpin();
  }

  async customerBetWithoutLoader() {
    const payload = this.createCustomerBetPayload();
    try {
      const response = await firstValueFrom(
        this._apiCall.PostCallWithToken(payload, 'Spinner/CustomerBet'),
      );
      if (response.responseCode === 200) {
        this.customerBetWinningAmount = response.data;

        const prizeToFind = '$' + this.customerBetWinningAmount;
        const prizeIndex = this.segments.findIndex(
          (segment) => segment.prize === prizeToFind,
        );

        if (this.currentSpinInterval) {
          clearInterval(this.currentSpinInterval);
          this.currentSpinInterval = null;
        }

        if (prizeIndex === -1) {
          const hasCloseMatch = this.findClosestPrizeMatch(
            this.customerBetWinningAmount,
          );

          if (!hasCloseMatch) {
            await this.completeSpinToRandomIndex();
            Swal.fire({
              icon: 'warning',
              title: 'Try Again',
              text: 'Prize not found. Please try again.',
              customClass: { popup: 'swal-compact' },
            });
          } else {
            await this.completeSpinToTarget(this.customerBetWinningAmount);
          }
        } else {
          await this.completeSpinToTarget(this.customerBetWinningAmount);
        }

        this.loaderService?.triggerWalletFunction();
      } else {
        this.stopSpinningWithError();
        this._httpError.handleResponseError(response);
      }
    } catch (error: any) {
      this.stopSpinningWithError();
      this._httpError.handleHttpError(error);
    }
  }

  private completeSpinToTarget(winningAmount: number): Promise<void> {
    return new Promise((resolve) => {
      if (this.currentSpinInterval) {
        clearInterval(this.currentSpinInterval);
        this.currentSpinInterval = null;
      }

      const prizeToFind = '$' + winningAmount;
      const prizeIndex = this.segments.findIndex(
        (segment) => segment.prize === prizeToFind,
      );

      let chosenIndex: number;

      if (prizeIndex !== -1) {
        chosenIndex = prizeIndex;
      } else {
        const numericPrizes = this.segments.map((segment) => {
          const numValue = parseFloat(segment.prize.replace(/[^0-9.]/g, ''));
          return {
            index: this.segments.indexOf(segment),
            id: segment.id,
            prize: segment.prize,
            numValue: numValue,
            difference: Math.abs(numValue - winningAmount),
          };
        });

        numericPrizes.sort((a, b) => a.difference - b.difference);

        if (
          numericPrizes.length > 0 &&
          numericPrizes[0].difference <= winningAmount * 0.2
        ) {
          chosenIndex = numericPrizes[0].index;
        } else {
          chosenIndex = Math.floor(Math.random() * this.segments.length);
          Swal.fire({
            icon: 'warning',
            title: 'Try Again',
            text: 'No matching prize found. Please try again.',
            customClass: { popup: 'swal-compact' },
          });
        }
      }

      const spinnerContainer = document.querySelector('.spinner-container');
      const segmentAngle = this.segmentAngle;
      const currentPointerAngle = ((-this.rotation % 360) + 360) % 360;
      const sliceStart = chosenIndex * segmentAngle;
      const sliceEnd = sliceStart + segmentAngle;
      const desiredCenterAngle = sliceStart + segmentAngle / 2;

      const settleOffset = 8 + Math.random() * 10;

      let delta = (desiredCenterAngle - currentPointerAngle + 360) % 360;
      const FULL_ROTATIONS = 6;
      delta += FULL_ROTATIONS * 360;
      const finalTargetRotation = this.rotation - delta + settleOffset;

      const startTime = performance.now();
      const initialRotation = this.rotation;
      const totalDistance = Math.abs(finalTargetRotation - initialRotation);

      const TOTAL_DURATION = 5000;

      let animationFrame: number;

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const t = Math.min(elapsed / TOTAL_DURATION, 1);

        const eased = 1 - Math.pow(1 - t, 3);

        const currentRotation = initialRotation - totalDistance * eased;

        this.rotation = currentRotation;
        if (t >= 1) {
          this.rotation = finalTargetRotation;
          this.completeSpinAnimation(
            chosenIndex,
            spinnerContainer,
            sliceStart,
            sliceEnd,
            desiredCenterAngle,
            resolve,
          );
          return;
        }

        this.cdr.detectChanges();
        animationFrame = requestAnimationFrame(animate);
      };

      animationFrame = requestAnimationFrame(animate);

      setTimeout(() => {
        if (this.isSpinning) {
          spinnerContainer?.classList.remove('spinning');
          spinnerContainer?.classList.add('spin-ending');
        }
      }, TOTAL_DURATION * 0.6);
    });
  }

  private findClosestPrizeMatch(winningAmount: number): boolean {
    const numericPrizes = this.segments.map((segment) => {
      const numValue = parseFloat(segment.prize.replace(/[^0-9.]/g, ''));
      return {
        index: this.segments.indexOf(segment),
        prize: segment.prize,
        numValue: numValue,
        difference: Math.abs(numValue - winningAmount),
      };
    });

    numericPrizes.sort((a, b) => a.difference - b.difference);

    if (
      numericPrizes.length > 0 &&
      numericPrizes[0].difference <= winningAmount * 0.2
    ) {
      return true;
    }
    return false;
  }

  private completeSpinToRandomIndex(): Promise<void> {
    return new Promise((resolve) => {
      if (this.currentSpinInterval) {
        clearInterval(this.currentSpinInterval);
        this.currentSpinInterval = null;
      }

      const randomIndex = Math.floor(Math.random() * this.segments.length);

      const spinnerContainer = document.querySelector('.spinner-container');
      const segmentAngle = this.segmentAngle;
      const currentPointerAngle = ((-this.rotation % 360) + 360) % 360;
      const sliceStart = randomIndex * segmentAngle;
      const sliceEnd = sliceStart + segmentAngle;
      const desiredCenterAngle = sliceStart + segmentAngle / 2;

      const settleOffset = 8 + Math.random() * 10;

      let delta = (desiredCenterAngle - currentPointerAngle + 360) % 360;
      const FULL_ROTATIONS = 4;
      delta += FULL_ROTATIONS * 360;
      const finalTargetRotation = this.rotation - delta + settleOffset;

      const startTime = performance.now();
      const initialRotation = this.rotation;
      const totalDistance = Math.abs(finalTargetRotation - initialRotation);

      const TOTAL_DURATION = 4000;

      let animationFrame: number;

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const t = Math.min(elapsed / TOTAL_DURATION, 1);

        const eased = 1 - Math.pow(1 - t, 3);
        const currentRotation = initialRotation - totalDistance * eased;

        this.rotation = currentRotation;
        if (t >= 1) {
          this.rotation = finalTargetRotation;
          this.completeRandomSpinAnimation(
            randomIndex,
            spinnerContainer,
            resolve,
          );
          return;
        }

        this.cdr.detectChanges();
        animationFrame = requestAnimationFrame(animate);
      };

      animationFrame = requestAnimationFrame(animate);

      setTimeout(() => {
        if (this.isSpinning) {
          spinnerContainer?.classList.remove('spinning');
          spinnerContainer?.classList.add('spin-ending');
        }
      }, TOTAL_DURATION * 0.6);
    });
  }

  private completeRandomSpinAnimation(
    chosenIndex: number,
    spinnerContainer: Element | null,
    onComplete?: () => void,
  ): void {
    this.isSpinning = false;
    document.body.style.pointerEvents = 'auto';

    spinnerContainer?.classList.remove('spinning', 'spin-ending');

    this.addPointerSettleEffect();

    this.highlightedIndex = chosenIndex;
    this.scheduleHighlightClear();

    this.cdr.detectChanges();
    if (onComplete) onComplete();
  }

  private stopSpinningWithError(): void {
    if (this.currentSpinInterval) {
      clearInterval(this.currentSpinInterval);
      this.currentSpinInterval = null;
    }

    if (this.isSpinning) {
      this.completeSpinToRandomIndex();
      return;
    }

    document.body.style.pointerEvents = 'auto';
    const spinnerContainer = document.querySelector('.spinner-container');
    spinnerContainer?.classList.remove('spinning', 'spin-ending');
    this.highlightedIndex = null;
    this.rotation = this.rotation % 360;
    this.cdr.detectChanges();
  }

  customerBetWinningAmount: number = 0;

  createCustomerBetPayload() {
    return {
      betType: 'spinner',
      customerId: localStorage.getItem('customerId'),
      bet: this.spinAmount,
    };
  }

  showGuide() {
    const steps: GuideStep[] = [
      {
        imageUrlSm: '/Images/Spinner/Spinner.png',

        // imageUrlLg: '/Images/user-manual/spinner/user-manual.png',
        // alt: 'Wallet overview screenshot',
      },
    ];

    this._utils.open(steps, 0, {
      title: 'Spinner Walkthrough',
      imageOnly: true,
    });
  }
  RedirectToWallet() {
    this._httpError.showModalSubject.next(true);
  }
}
